/**
 * Message Type Mapper
 *
 * Converts between LocalChatMessage (S3 storage format) and ChatMessage (UI format)
 * This resolves the type mismatch between s3-chat-store and chat-store
 */

import type { ChatMessage } from '../stores/chat-store';
import type { LocalChatMessage } from '../stores/s3-chat-store';

/**
 * Convert LocalChatMessage (S3 format) to ChatMessage (UI format)
 */
export const mapLocalMessageToChatMessage = (localMessage: LocalChatMessage): ChatMessage => {
  return {
    id: localMessage.id,
    content: localMessage.content,
    sender: localMessage.sender,
    timestamp: localMessage.timestamp,
    status: localMessage.status || 'sent',
    attachedFiles: localMessage.attachedFiles,
    ...(localMessage.pageContext ? { pageContext: localMessage.pageContext } : {}),
  } as ChatMessage;
};

/**
 * Convert array of LocalChatMessages to ChatMessages
 */
export const mapLocalMessagesToChatMessages = (
  localMessages: LocalChatMessage[]
): ChatMessage[] => {
  return localMessages.map(mapLocalMessageToChatMessage);
};

/**
 * Convert ChatMessage (UI format) to LocalChatMessage (S3 format)
 * Note: This is primarily for backward compatibility. New messages should use S3 directly.
 */
export const mapChatMessageToLocalMessage = (chatMessage: ChatMessage): LocalChatMessage => {
  return {
    id: chatMessage.id,
    content: chatMessage.content,
    sender: chatMessage.sender === 'user' ? 'user' : 'ai',
    timestamp: new Date(chatMessage.timestamp).toISOString(),
    attachedFiles: [],
    status: chatMessage.status,
  };
};
